import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_PROCESS_OPTIONS = '/process-options';

export const SET_PROCESS_OPTIONS_LOADING = 'SET_PROCESS_OPTIONS_LOADING';
export const GET_PROCESS_OPTIONS = 'GET_PROCESS_OPTIONS';
export const GET_PROCESS_OPTIONS_PENDING = 'GET_PROCESS_OPTIONS_PENDING';
export const GET_PROCESS_OPTIONS_FULFILLED = 'GET_PROCESS_OPTIONS_FULFILLED';
export const GET_PROCESS_OPTIONS_REJECTED = 'GET_PROCESS_OPTIONS_REJECTED';
export const GET_PROCESS_OPTIONS_LIST = 'GET_PROCESS_OPTIONS_LIST';
export const GET_PROCESS_OPTIONS_LIST_PENDING = 'GET_PROCESS_OPTIONS_LIST_PENDING';
export const GET_PROCESS_OPTIONS_LIST_FULFILLED = 'GET_PROCESS_OPTIONS_LIST_FULFILLED';

export const GO_TO_PROCESS_OPTIONS_CREATE = 'GO_TO_PROCESS_OPTIONS_CREATE';
export const GO_TO_PROCESS_OPTIONS_LIST = 'GO_TO_PROCESS_OPTIONS_LIST';
export const GO_TO_PROCESS_OPTIONS_EDIT = 'GO_TO_PROCESS_OPTIONS_EDIT';
export const GO_TO_PROCESS_OPTIONS_VIEW = 'GO_TO_PROCESS_OPTIONS_VIEW';
export const CREATE_PROCESS_OPTIONS = 'CREATE_PROCESS_OPTIONS';
export const CREATE_PROCESS_OPTIONS_PENDING = 'CREATE_PROCESS_OPTIONS_PENDING';
export const CREATE_PROCESS_OPTIONS_FULFILLED = 'CREATE_PROCESS_OPTIONS_FULFILLED';
export const CREATE_PROCESS_OPTIONS_REJECTED = 'CREATE_PROCESS_OPTIONS_REJECTED';
export const UPDATE_PROCESS_OPTIONS = 'UPDATE_PROCESS_OPTIONS';
export const UPDATE_PROCESS_OPTIONS_FULFILLED = 'UPDATE_PROCESS_OPTIONS_FULFILLED';
export const UPDATE_PROCESS_OPTIONS_REJECTED = 'UPDATE_PROCESS_OPTIONS_REJECTED';
export const DELETE_PROCESS_OPTIONS = 'DELETE_PROCESS_OPTIONS';
export const DELETE_PROCESS_OPTIONS_FULFILLED = 'DELETE_PROCESS_OPTIONS_FULFILLED';
export const DELETE_PROCESS_OPTIONS_REJECTED = 'DELETE_PROCESS_OPTIONS_REJECTED';
export const SELECT_PROCESS_OPTIONS = 'SELECT_PROCESS_OPTIONS';

export enum ProcessOptionPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface ProcessOption {
  id: string
  PROCNAME: string
  PARAMNAME: string
  PARAMVALUE: string
  COMMENTS: string
}

export interface ProcessOptionState {
  entities: ProcessOption[]
  selected: ProcessOption[]
  single: ProcessOption | null
  createdId: string | null
  ui: ProcessOptionsUIState
}

export interface ProcessOptionsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GetProcessOptionAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS
  payload: AxiosPromise<ServerResponse<ProcessOption>>
}

export interface GetProcessOptionPendingAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS_PENDING
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface GetProcessOptionFulfilledAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface GetProcessOptionRejectedAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface GoToProcessOptionListAction extends AnyAction {
  type: typeof GO_TO_PROCESS_OPTIONS_LIST
}

export interface SetProcessOptionLoadingAction extends AnyAction {
  type: typeof SET_PROCESS_OPTIONS_LOADING
  payload: { isLoading: boolean }
}

export interface GetProcessOptionsListAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS_LIST
  payload: AxiosPromise<ServerResponse<ProcessOption>>
}

export interface GetProcessOptionsListPendingAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS_LIST_PENDING
  payload: null
}

export interface GetProcessOptionsListFulfilledAction extends AnyAction {
  type: typeof GET_PROCESS_OPTIONS_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface CreateProcessOptionsThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateProcessOptionsAction extends AnyAction {
  type: typeof CREATE_PROCESS_OPTIONS
  payload: AxiosPromise<ServerResponse<ProcessOption>>
}

export interface CreateProcessOptionsPendingAction extends AnyAction {
  type: typeof CREATE_PROCESS_OPTIONS_PENDING
  payload: null
}

export interface CreateProcessOptionsFulfilledAction extends AnyAction {
  type: typeof CREATE_PROCESS_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface CreateProcessOptionsRejectedAction extends AnyAction {
  type: typeof CREATE_PROCESS_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface UpdateProcessOptionsThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateProcessOptionsAction extends AnyAction {
  type: typeof UPDATE_PROCESS_OPTIONS
  payload: AxiosPromise<ServerResponse<ProcessOption>>
}

export interface UpdateProcessOptionsFulfilledAction extends AnyAction {
  type: typeof UPDATE_PROCESS_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface UpdateProcessOptionsRejectedAction extends AnyAction {
  type: typeof UPDATE_PROCESS_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface DeleteProcessOptionsThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteProcessOptionsAction extends AnyAction {
  type: typeof DELETE_PROCESS_OPTIONS
  payload: AxiosPromise<ServerResponse<ProcessOption>>
}

export interface DeleteProcessOptionsFulfilledAction extends AnyAction {
  type: typeof DELETE_PROCESS_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface DeleteProcessOptionsRejectedAction extends AnyAction {
  type: typeof DELETE_PROCESS_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<ProcessOption>>
}

export interface SelectProcessOptionAction extends AnyAction{
  type: typeof SELECT_PROCESS_OPTIONS
  payload: ProcessOption[]
}

export type ProcessOptionActionTypes =
  GetProcessOptionAction |
  GetProcessOptionPendingAction |
  GetProcessOptionFulfilledAction |
  GetProcessOptionRejectedAction |
  GetProcessOptionsListAction |
  GetProcessOptionsListPendingAction |
  GetProcessOptionsListFulfilledAction |
  SetProcessOptionLoadingAction |
  GoToProcessOptionListAction |
  CreateProcessOptionsAction |
  CreateProcessOptionsPendingAction |
  CreateProcessOptionsFulfilledAction |
  CreateProcessOptionsRejectedAction |
  UpdateProcessOptionsAction |
  UpdateProcessOptionsFulfilledAction |
  UpdateProcessOptionsRejectedAction |
  DeleteProcessOptionsAction |
  DeleteProcessOptionsFulfilledAction |
  DeleteProcessOptionsRejectedAction |
  SelectProcessOptionAction;
